module.exports = __webpack_public_path__ + "static/media/binance-save-figure.65455d44.png";